import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function ContactForm() {
  const [inputValue, setInputValue] = useState({
    name: "",
    company: "",
    email: "",
    service: "",
    budget: "",
    details: ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  // Handle input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setInputValue({
      ...inputValue,
      [name]: value
    });
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      const response = await fetch("YOUR_API_ENDPOINT", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(inputValue)
      });

      if (!response.ok) {
        throw new Error("Something went wrong with form submission.");
      }

      setSuccess(true);
    } catch (error) {
      setError("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen"
      data-aos="fade-right"
      data-aos-anchor="#example-anchor"
      data-aos-offset="500"
      data-aos-duration="500"
    >
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-4xl">
        <div className="flex flex-col md:flex-row">
          <div className="md:w-1/2">
            <img
              src="https://static.vecteezy.com/system/resources/previews/000/158/932/large_2x/bookkeeping-vector-illustration.png"
              alt="Abstract glass object"
              className="w-full h-auto rounded-lg"
            />
          </div>
          <div className="md:w-1/2 md:pl-8 mt-8 md:mt-0">
            <h1 className="text-4xl font-bold mb-4">Have a Project Idea?</h1>
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="flex flex-col md:flex-row md:space-x-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:border-black focus:outline-none"
                    placeholder="Jane Cooper"
                    value={inputValue.name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Company name
                  </label>
                  <input
                    type="text"
                    name="company"
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:border-black focus:outline-none"
                    placeholder="Ex. Tesla Inc"
                    value={inputValue.company}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div className="flex flex-col md:flex-row md:space-x-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Email*
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:border-black focus:outline-none"
                    placeholder="You@Example.Com"
                    value={inputValue.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="flex flex-col md:flex-row md:space-x-4">
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Service required*
                  </label>
                  <select
                    name="service"
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:border-black focus:outline-none"
                    value={inputValue.service}
                    onChange={handleInputChange}
                  >
                    <option>Select Your Service</option>
                    <option value="WebDesign">Web Design</option>
                    <option value="WebDevelopment">Web Development</option>
                    <option value="DigitalMarketing">Digital Marketing</option>
                    <option value="AppDevelopment">App Development</option>
                    <option value="UIDesign">UI Design</option>
                    <option value="SaaSDesign">SaaS Design</option>
                    <option value="VideoEditing">Video Editing</option>
                    <option value="Branding">Branding</option>
                    <option value="WebFlow">WebFlow</option>
                  </select>
                </div>
                <div className="flex-1">
                  <label className="block text-sm font-medium text-gray-700">
                    Project budget*
                  </label>
                  <select
                    name="budget"
                    className="mt-1 block w-full border-b-2 border-gray-400 focus:border-black focus:outline-none"
                    value={inputValue.budget}
                    onChange={handleInputChange}
                  >
                    <option>Select Your Range</option>
                    <option>$1,000 - $5,000</option>
                    <option>$5,000 - $10,000</option>
                    <option>$10,000 - $20,000</option>
                    <option>$21,000 - $30,000</option>
                    <option>$31,000 - $40,000</option>
                    <option>$41,000 - $50,000</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Project details*
                </label>
                <textarea
                  name="details"
                  className="mt-1 block w-full border-b-2 border-gray-400 focus:border-black focus:outline-none"
                  rows="3"
                  value={inputValue.details}
                  onChange={handleInputChange}
                  placeholder="Tell us more about your idea"
                />
              </div>
              <div className="flex justify-center">
                <button
                  type="submit"
                  className="bg-black text-white py-2 px-4 rounded-full"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send inquiry"}
                </button>
              </div>
              {success && <p className="text-green-600">Inquiry sent successfully!</p>}
              {error && <p className="text-red-600">{error}</p>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
